import React from 'react';
import { Link } from 'react-router-dom';

import '../../static/Footer.css';
import '../../static/Global.css';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="boutique-footer">
      <div className="container boutique-footer-container">
        
        {/* FILA SUPERIOR: LOGO BOUTIQUE Y MANIFIESTO */}
        <div className="footer-top-row">
          
          <div className="footer-brand-column">
            <Link to="/" className="footer-brand-link" onClick={scrollToTop}>
              <span className="brand-dot"></span>
              <span className="footer-brand-title">YCORE</span>
              <span className="footer-brand-sub">STUDIO</span>
            </Link>
            <p className="footer-manifesto-text">
              Impulsamos tu negocio al siguiente nivel con software, páginas web y soluciones informáticas creadas a tu medida.
            </p>
            <div className="footer-social-links">
              <a href="https://www.instagram.com/novatechzz/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon-btn">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=100089989401567" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon-btn">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="https://api.whatsapp.com/send?phone=51906145083&text=Saludos YCore Studio!%20Quisiera%20ponerme%20en%20contacto%20con%20un%20asesor." target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="social-icon-btn">
                <i className="fa-brands fa-whatsapp"></i>
              </a>
            </div>
          </div>

          {/* COLUMNA 1: COLECCIÓN Y NAVEGACIÓN PRINCIPAL */}
          <div className="footer-nav-column">
            <h6 className="footer-column-title">Colección</h6>
            <ul className="footer-links-list">
              <li><Link to="/" onClick={scrollToTop}>Inicio</Link></li>
              <li><Link to="/productos" onClick={scrollToTop}>Catálogo Completo</Link></li>
              <li><Link to="/reseñas" onClick={scrollToTop}>Opiniones & Reseñas</Link></li>
              <li><Link to="/aboutus" onClick={scrollToTop}>Contacto & Asesoría</Link></li>
            </ul>
          </div>

          {/* COLUMNA 2: ATENCIÓN Y GARANTÍA */}
          <div className="footer-nav-column">
            <h6 className="footer-column-title">Atelier & Soporte</h6>
            <ul className="footer-links-list">
              <li><a href="/#faq">Preguntas Frecuentes</a></li>
              <li><Link to="/aboutus" onClick={scrollToTop}>Proyectos Especiales</Link></li>
              <li><Link to="/aboutus" onClick={scrollToTop}>Contactar con un asesor</Link></li>
            </ul>
          </div>

          {/* COLUMNA 3: CONTACTO DIRECTO */}
          <div className="footer-nav-column">
            <h6 className="footer-column-title">Contacto Directo</h6>
            <ul className="footer-contact-info">
              <li>
                <i className="fa-solid fa-location-dot"></i>
                <span>Lima Metropolitana, Perú</span>
              </li>
              <li>
                <i className="fa-solid fa-envelope"></i>
                <span>novatech2023@hotmail.com</span>
              </li>
              <li>
                <i className="fa-solid fa-phone"></i>
                <span>+51 906 145 083</span>
              </li>
            </ul>
          </div>

        </div>

        {/* FILA INFERIOR: COPYRIGHT Y POLÍTICAS */}
        <div className="footer-bottom-row">
          <p className="footer-copyright">
            © 2026 YCore Studio. Todos los derechos reservados.
          </p>
          <button onClick={scrollToTop} className="btn-back-to-top" title="Volver arriba">
            <span>Subir</span>
            <i className="fa-solid fa-arrow-up"></i>
          </button>
        </div>

      </div>
    </footer>
  );
}

export default Footer;